<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :sm="12" :md="4" :lg="4">
          <el-cascader
            style="width: 100%"
            clearable
            v-model="searchForm.campusId"
            :show-all-levels="false"
            :props="CampusProps"
            placeholder="请选择所属校区"
            :options="campusList"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-select
            clearable
            placeholder="请选择角色"
            style="width: 100%"
            v-model="searchForm.roleId"
          >
            <el-option
              v-for="i in organizations"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入姓名/手机"
            auto-complete="off"
          ></el-input>
        </el-col>
        <!-- <el-col :sm="12" :md="4" :lg="4">
          <el-select style="width:100%" clearable v-model="searchForm.enabled" placeholder="状态">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>-->
        <el-col :sm="12" :md="5" :lg="12">
          <el-button
            type="primary"
            @click="(page.pageNumber = 1), pageList()"
            icon="el-icon-search"
            v-auth="'/agentUserInfoAdmin/pageList'"
            >查询</el-button
          >
          <el-button
            type="primary"
            style="float: right; margin-left: 20px"
            @click="(addFormVisible = true), getCampusList()"
            icon="el-icon-plus"
            v-auth="'/agentUserInfoAdmin/addCampusTree'"
            >添加员工
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <!-- <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">添加代理人员</el-button> -->
          <!-- <el-button type="danger" @click="batchDeleteAgentUserInfo" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
        <!-- <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 0px; width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="name" label="姓名" width="100"></el-table-column>
        <el-table-column prop="account" label="手机" width="150"></el-table-column>
        <!-- <el-table-column prop="agentInfo.name" label="所属机构"></el-table-column> -->
        <el-table-column prop="campusName" label="所属校区"></el-table-column>
        <el-table-column prop="roleName" label="角色"></el-table-column>
        <!-- <el-table-column prop="amount" label="账户余额(元)"></el-table-column> -->
        <el-table-column
          prop="enabled"
          label="状态"
          width="100"
          align="center"
          :render-header="renderSpecNameHeader"
        >
          <template slot-scope="row">
            <!-- <el-switch v-model="row.row.enabled" @change="updateSwitching(row)"></el-switch> -->
            <el-switch
              @change="updateSwitching(row)"
              :active-value="1"
              :inactive-value="-1"
              active-text="开"
              inactive-text="关"
              class="switchStyle"
              v-model="row.row.enabled"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button
                type="text"
                @click="
                  (selection = scope.row.id), (editFormVisible = true), getCampusList()
                "   v-auth="'/agentUserInfoAdmin/editCampusTree'"
                >编辑</el-button
              >
              <el-button type="text" @click="resetPassword(scope.row.id)"   v-auth="'/agentUserInfoAdmin/resetPassword'"
                >重置密码</el-button
              >
              <el-button type="text" @click="openDataBindModal(scope.row)"   v-auth="'/agentUserInfoAdmin/openDataBindModal'"
                >数据绑定</el-button
              >
              <!-- <el-button
                type="text"
                @click="selection = scope.row.id,agentAmountLogPageList(scope.row.id)"
              >开通记录</el-button> -->
              <!-- <span @click="deleteStudent(scope.row.id)">解除绑定</span> -->
              <!-- <span @click="deleteAgentUserInfo(scope.row)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px; text-align: left"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加人员" :visible.sync="addFormVisible" width="400px" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row :gutter="20">
          <!-- <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="账号" prop="account">
          <el-input v-model="addForm.account" placeholder="请输入账号" auto-complete="off" maxlength="50"></el-input>
        </el-form-item>
          </el-col>-->
          <el-col :sapn="24">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="addForm.campusId"
                :show-all-levels="false"
                :props="CampusProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构可分配余额(元)：" label-width="200">{{amount}}</el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="角色" prop="roleId">
              <el-select
                style="width: 100%"
                placeholder="请选择角色"
                v-model="addForm.roleId"
                @change="organizationsChange"
              >
                <el-option
                  clearable
                  v-for="i in organizations"
                  :key="i.id"
                  :label="i.name"
                  :value="i.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="账户余额" prop="amount">
              <el-input
                type="number"
                v-model="addForm.amount"
                placeholder="请输入金额"
                auto-complete="off"
                maxlength="18"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="手机号码" prop="account">
              <el-input
                v-model="addForm.account"
                placeholder="请输入手机号码"
                auto-complete="new-account"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="人员姓名" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入姓名"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="同步学员" prop="syncStudentInfo">
              <el-radio v-model="addForm.syncStudentInfo" :label="1">是</el-radio>
              <el-radio v-model="addForm.syncStudentInfo" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio v-model="addForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="addForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="登录密码" prop="password">
              <el-input
                v-model="addForm.password"
                placeholder="请输入登录密码"
                auto-complete="new-password"
                maxlength="50"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑人员"
      :visible.sync="editFormVisible"
      width="400px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="editForm.campusId"
                :show-all-levels="false"
                :props="CampusProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="角色" prop="roleId">
              <el-select
                clearable
                placeholder="请选择角色"
                style="width: 100%"
                v-model="editForm.roleId"
                @change="editOrganizationsChange"
              >
                <el-option
                  v-for="i in organizations"
                  :key="i.id"
                  :label="i.name"
                  :value="i.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="人员姓名" prop="name">
              <el-input
                style="width: 100%"
                v-model="editForm.name"
                placeholder="请输入姓名"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号码" prop="account">
              <el-input
                v-model="editForm.account"
                placeholder="请输入手机号码"
                auto-complete="new-account"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="同步学员" prop="syncStudentInfo">
              <el-radio v-model="editForm.syncStudentInfo" :label="1">是</el-radio>
              <el-radio v-model="editForm.syncStudentInfo" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="数据绑定" :visible.sync="dataBindModal" width="400px" left>
      <el-form
        ref="bindForm"
        :model="bindForm"
        :label-width="formLabelWidth"
        :rules="bindFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="校区" prop="campusId">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="bindForm.campusIdList"
                :show-all-levels="false"
                :props="campusTreeProps"
                placeholder="请选择所属校区"
                :options="campusList"
                collapse-tags
                @change="campusIdListChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="科目" prop="subjectId">
              <el-cascader
                style="width: 100%"
                clearable
                collapse-tags
                v-model="bindForm.courseIds"
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectChangeTop"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="dataBindModal = false">取 消</el-button>
        <el-button type="primary" @click="updateBindConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "md5";
import { mapGetters } from "vuex";
import SelectHeader from "./SelectHeaderAdmin";

export default {
  data() {
    return {
      dataBindModal: false,
      blockAddAgentUserInfo: false,
      subjectTreeList: [],
      blockUpdateAgentUserInfo: false,
      amountStats: {},
      activeName: "first",
      amount: "",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
      },
      campusList: [],
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: "",
        enabled: "",
        campusId: null,
        roleId: null,
      },
      addForm: {
        account: "",
        roleId: "",
        name: "",
        amount: "",
        enabled: "1",
        campusId: undefined,
        syncStudentInfo: 0,
      },
      addFormRules: {
        syncStudentInfo: {
          required: true,
          message: "请选择",
          trigger: "change",
        },
        campusId: {
          required: true,
          message: "请选择校区",
          trigger: "change",
        },
        roleId: {
          required: true,
          message: "请选择角色",
          trigger: "change",
        },
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字",
          },
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur",
        },
      },
      editForm: {
        roleId: "",
        account: "",
        name: "",
        amount: "",
        enabled: "",
        campusId: undefined,
        syncStudentInfo: 0,
      },
      bindForm: {
        campusIdList: [],
        courseIds: [],
      },
      bindFormRules: {},
      editFormRules: {
        syncStudentInfo: {
          required: true,
          message: "请选择",
          trigger: "change",
        },
        campusId: {
          required: true,
          message: "请选择校区",
          trigger: "change",
        },
        roleId: {
          required: true,
          message: "请选择角色",
          trigger: "change",
        },
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字",
          },
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur",
        },
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      options: [
        { id: "", name: "全部" },
        { id: 1, name: "启用" },
        { id: 0, name: "禁用" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/agentUserInfo/upload`,
      fileList: [],
      loading: true,
      loading: false,
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      campusIdList: [],
      courseIds: [],
      selectRow: {},
      organizations: [],
    };
  },
  methods: {
    campusIdListChange(val) {
      this.bindForm.campusIdList = val;
      this.campusIdList = [];
      val.forEach((e) => {
        console.log("val", val);
        this.campusIdList.push(e[2]);
      });
    },
    subjectChangeTop(val) {
      this.bindForm.courseIds = val;
      this.courseIds = [];
      val.forEach((e) => this.courseIds.push(e[1]));
    },
    updateBindConfirm() {
      this.api.agentUserInfo
        .updateUserBind({
          id: this.selectRow.id,
          campusIdList: this.campusIdList,
          subjectIdList: this.courseIds,
        })
        .then((res) => {
          this.dataBindModal = false;
          if (res.success) {
            this.$message.success("操作成功");
          }
        });
    },
    getSubjectTreeList() {
      this.api
        .getSubjectTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openDataBindModal(row) {
      this.dataBindModal = true;
      this.selectRow = row;
      this.campusIdList = [];
      this.courseIds = [];
      this.api.agentUserInfo.getUserBindData({ id: row.id }).then((res) => {
        this.bindForm = {
          campusIdList: res.data.campusCascadeIdList || [],
          courseIds: res.data.subjectCascadeIdList || [],
        };
        res.data.campusCascadeIdList.forEach((e) => {
          this.campusIdList.push(e[2]);
        });
        res.data.subjectCascadeIdList.forEach((e) => {
          this.courseIds.push(e[1]);
        });
        console.log(this.courseIds);
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    userInfoSizeChange(pageSize) {
      this.userInfo.pageSize = pageSize;
      this.agentAmountLogPageList();
    },
    userInfoCurrentChange(pageNumber) {
      this.userInfo.pageNumber = pageNumber;
      this.agentAmountLogPageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getAgentUserInfo() {
      this.api.agentUserInfo
        .getAgentUserInfo({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          if (!this.editForm.syncStudentInfo) {
            this.$set(this.editForm, "syncStudentInfo", 0);
          }
          this.editForm.enabled = String(this.editForm.enabled);
          this.editOrganizationsChange();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled,
      };
      this.api.agentUserInfo.enabledUser(obj).then((result) => {
        if (result.success) {
          this.$message.success(result.message);
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;
      //该列的绑定数据
      // console.log(column);
      //列号
      // console.log($index);
      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:30px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.page.pageNumber = 1;
      this.searchForm.enabled = val;
      this.pageList();
    },
    pageList() {
      this.loading = true;
      let obj=Object.assign({},this.searchForm)
      if (obj.campusId) {
        if (obj.campusId.length > 0) {
          let len = obj.campusId.length;
          obj.campusId = obj.campusId[len - 1];
        } else {
          obj.campusId = null;
        }
      }
      obj.account = obj.name;
      obj.pageSize = this.page.pageSize;
      obj.pageNumber = this.page.pageNumber;
      obj.sortName = this.page.sortName;
      obj.sortOrder = this.page.sortOrder;
      obj.agentId = this.loginData.agentId;
      this.api.agentUserInfo
        .pageList(obj)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAgentUserInfo() {
      if (this.blockAddAgentUserInfo) {
        return false;
      }
      this.blockAddAgentUserInfo = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (typeof this.addForm.campusId == "object") {
            let index = this.addForm.campusId.length;
            this.addForm.campusId = this.addForm.campusId[index - 1];
          }
          this.addForm.agentId = this.loginData.agentId;
          this.api.agentUserInfo
            .addAgentUserInfo(this.addForm)
            .then((result) => {
              if (result.success) {
                this.blockAddAgentUserInfo = false;
                this.addFormVisible = false;
                this.pageList();
                this.$message.success(result.message);
              } else {
                this.blockAddAgentUserInfo = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentUserInfo() {
      if (this.blockUpdateAgentUserInfo) {
        return false;
      }
      this.blockUpdateAgentUserInfo = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (typeof this.editForm.campusId == "object") {
            let index = this.editForm.campusId.length;
            this.editForm.campusId = this.editForm.campusId[index - 1];
          }
          this.editForm.agentId = this.loginData.agentId;
          this.api.agentUserInfo
            .updateAgentUserInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.blockUpdateAgentUserInfo = false;
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.blockUpdateAgentUserInfo = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              this.blockUpdateAgentUserInfo = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentUserInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    resetPassword(row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.agentUserInfo.resetPassword({ id: row }).then((result) => {
          if (result.success) {
            this.$message.success("操作成功，密码为您的手机号！");
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    agentAmountLogPageList(id) {
      this.getAgentAmountStatsDTO();
      let obj = {
        pageNumber: this.userInfoPage.pageNumber,
        pageSize: this.userInfoPage.pageSize,
        userId: this.selection,
      };
      this.api.agentUserInfo.agentAmountLogPageList(obj).then((result) => {
        this.userInfoPage.rows = result.data.records;
        this.userInfoPage.type = result.total;
        this.activeName = "second";
        this.editFormVisible = true;
      });
      this.api.agentUserInfo
        .getAgentUserAmountStats({ id: this.selection })
        .then((result) => {
          this.amountStats = result.data;
        });
    },
    getAgentAmountStatsDTO() {
      this.api.agentUserInfo.getAgentAmountStatsDTO().then((result) => {
        this.amount = result.data.amount;
      });
    },
    deleteStudent(row) {
      this.$confirm("您确定要解除绑定吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.student.deleteStudent([{ id: row }]).then((resule) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    batchDeleteAgentUserInfo() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.agentUserInfo
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.agentUserInfo
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAgentInfoList() {
      // this.api.agentUserInfo.getAgentInfoList().then(result => {
      //   this.organizations = result.data;
      //   console.log("this.organizations", this.organizations);
      this.searchForm.agentId = this.loginData.agentId;
      // });
      this.api.agentRoleInfo
        .getAgentRoleInfoList({ agentId: this.loginData.agentId })
        .then((result) => {
          this.organizations = result.data;
        });
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    organizationsChange() {},
    editOrganizationsChange() {
      // this.organizations.forEach(item => {
      //   if (this.editForm.agentId == item.id) {
      //     this.amount = item.amount;
      //   }
      // });
    },
    handleClick(tab, event) {
      if (tab.name == "second") {
        this.agentAmountLogPageList();
      }
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.userInfoPage.rows = [];
        this.activeName = "first";
      } else {
        this.getAgentUserInfo();
      }
    },
  },
  filters: {
    NumFormat: function (value) {
      if (!value) return "0";
      var intPart = Number(value) | 0; // 获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = ""; //预定义小数部分
      var valueSplit = String(value);
      var value2Array = valueSplit.split(".");
      //=2表示数据有小数位
      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if (floatPart.length == 1) {
          //补0,实际上用不着
          return intPartFormat + "." + floatPart;
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    },
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
    this.getAgentInfoList();
    this.getCampusList();
    this.getAgentAmountStatsDTO();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/agentUserInfo/agentUserInfoAdmin.vue